"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _header = _interopRequireDefault(require("../header"));

var _axios = _interopRequireDefault(require("axios"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

var _message = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/message"));

var _ConfirmationModal = _interopRequireDefault(require("@insided/shared/uikit/Modal/ConfirmationModal"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SuppressionList = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SuppressionList, _Component);

  var _super = _createSuper(SuppressionList);

  function SuppressionList(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SuppressionList);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "inputElement", null);
    _this.state = {
      message: '',
      messageType: undefined,
      isModalOpen: false,
      isSuppressed: false,
      showClearButton: false,
      showNotFoundMessage: false
    };
    _this.onSubmit = _this.onSubmit.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClear = _this.onClear.bind((0, _assertThisInitialized2.default)(_this));
    _this.onRemoveClick = _this.onRemoveClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(SuppressionList, [{
    key: "onSubmit",
    value: function () {
      var _onSubmit = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
        var result;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();

                if (!this.inputElement) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 2;
                _context.next = 5;
                return _axios.default.post('/email/email-suppression-list/verify', {
                  email: this.inputElement.value.trim()
                });

              case 5:
                result = _context.sent;

                if (result.data.is_suppressed) {
                  this.setState({
                    isSuppressed: true,
                    showNotFoundMessage: false
                  });
                } else {
                  this.setState({
                    isSuppressed: false,
                    showNotFoundMessage: true
                  });
                }

                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);

                _logger.logger.error(_context.t0, {
                  component: 'SuppressionList',
                  action: 'checkSuppression'
                });

                this.setState({
                  message: 'Sorry, something went wrong, please try again.',
                  messageType: 'error'
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 9]]);
      }));

      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  }, {
    key: "onClear",
    value: function onClear() {
      this.setState({
        isSuppressed: false,
        showNotFoundMessage: false,
        showClearButton: false,
        message: '',
        messageType: undefined
      });

      if (this.inputElement) {
        this.inputElement.value = '';
      }
    }
  }, {
    key: "onChange",
    value: function onChange() {
      var _this$inputElement;

      this.setState({
        isSuppressed: false,
        message: '',
        messageType: undefined,
        showNotFoundMessage: false,
        showClearButton: !!((_this$inputElement = this.inputElement) !== null && _this$inputElement !== void 0 && _this$inputElement.value)
      });
    }
  }, {
    key: "onRemoveClick",
    value: function () {
      var _onRemoveClick = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.inputElement) {
                  _context2.next = 12;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return _axios.default.delete('/email/email-suppression-list/remove', {
                  params: {
                    email: this.inputElement.value.trim()
                  }
                });

              case 4:
                this.setState({
                  message: 'You’ve removed this email from suppression list.',
                  messageType: 'success',
                  isSuppressed: false,
                  showNotFoundMessage: false,
                  showClearButton: false,
                  isModalOpen: false
                });
                this.inputElement.value = '';
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);

                _logger.logger.error(_context2.t0, {
                  component: 'SuppressionList',
                  action: 'removeSuppression'
                });

                this.setState({
                  message: 'Sorry, something went wrong, please try again.',
                  messageType: 'error',
                  isModalOpen: false
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8]]);
      }));

      function onRemoveClick() {
        return _onRemoveClick.apply(this, arguments);
      }

      return onRemoveClick;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          isSuppressed = _this$state.isSuppressed,
          messageType = _this$state.messageType,
          message = _this$state.message,
          isModalOpen = _this$state.isModalOpen,
          showClearButton = _this$state.showClearButton,
          showNotFoundMessage = _this$state.showNotFoundMessage;
      return (0, _preact.h)("div", {
        "data-bounded-context": "Emails",
        "data-entity": "suppression-list"
      }, (0, _preact.h)(_header.default, {
        title: "Email Suppression List",
        disableSaveButton: true,
        disableCancelButton: true
      }), (0, _preact.h)("div", {
        className: "email-suppression-list"
      }, (0, _preact.h)("div", null, (0, _preact.h)(_assets.default, {
        customClass: "flagged-content-icon",
        width: 32,
        height: 32,
        icon: "flaggedContent"
      })), (0, _preact.h)("div", {
        className: "email-suppression-list-body"
      }, (0, _preact.h)("div", {
        className: "email-suppression-list-title"
      }, "Check if an email has been supressed"), (0, _preact.h)("div", {
        className: "email-suppression-list-description"
      }, "Remove any supressed email from the email suppression list"), (0, _preact.h)("div", {
        className: "email-suppression-list-search-label"
      }, "Search email in suppression list"), (0, _preact.h)("form", {
        className: "email-suppression-list-search-container form-group--new-style",
        onSubmit: this.onSubmit
      }, (0, _preact.h)(_assets.default, {
        customClass: "search-icon",
        width: 16,
        height: 16,
        icon: "search"
      }), (0, _preact.h)("input", {
        className: "email-suppression-list-search-input form-control",
        ref: function ref(inputElement) {
          _this2.inputElement = inputElement;
        },
        onInput: this.onChange,
        type: "email",
        placeholder: "Search email"
      }), showClearButton && (0, _preact.h)("button", {
        className: "email-suppression-list-search-clear",
        onClick: this.onClear,
        type: "reset",
        "data-track-type": "click",
        "data-element-name": "No auto suggestion for element name for this button"
      }, (0, _preact.h)(_assets.default, {
        width: 16,
        height: 16,
        icon: "cancel"
      })), isSuppressed && (0, _preact.h)(_buttonControl.default, {
        title: "Remove",
        variant: "warning",
        newStyle: true,
        size: "medium",
        onClick: function onClick() {
          _this2.setState({
            isModalOpen: true
          });
        },
        class: "delete-email-from-suppression-list qa-delete-email-from-suppression-list",
        "data-track-type": "click",
        "data-element-name": "Remove button"
      })), showNotFoundMessage && (0, _preact.h)("div", {
        className: "email-suppression-list-not-found"
      }, (0, _preact.h)(_assets.default, {
        width: 16,
        height: 16,
        icon: "warning"
      }), (0, _preact.h)("div", null, "This email is not on the supression list.")), message && (0, _preact.h)(_message.default, {
        isControl: true,
        variant: messageType,
        onDismiss: function onDismiss() {
          _this2.setState({
            message: '',
            messageType: undefined
          });
        }
      }, message), (0, _preact.h)(_ConfirmationModal.default, {
        isOpen: isModalOpen,
        handleConfirmation: this.onRemoveClick,
        onClose: function onClose() {
          _this2.setState({
            isModalOpen: false
          });
        },
        title: "Remove email from suppression list?",
        body: "You will remove this email from suppression list. This email will be able to receive any commercial communications.",
        action: (0, _absoluteUrlRuntime.resolveUrl)("Remove email"),
        variant: "brand"
      }))));
    }
  }]);
  return SuppressionList;
}(_preact.Component);

exports.default = SuppressionList;